import React, { useState } from 'react';
import './App.css';

function App() {
  // ステート`message`を定義し、初期値は空文字列です
  const [message, setMessage] = useState('');

  // 「取得」ボタンがクリックされた時に実行される関数
  const handleClick = () => {
    setMessage('hello'); // ステートを更新してメッセージを表示
  };

  return (
    <div className="App">
      <header className="App-header">
        <button onClick={handleClick}>取得</button> {/* ボタンにクリックイベントを設定 */}
        <p>{message}</p> {/* メッセージを表示 */}
      </header>
    </div>
  );
}

export default App;
